import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "sonner";
import { ownerApi } from "@/lib/api";
import { Spinner } from "@/components/common/States";
import { cn } from "@/lib/utils";

export default function OwnerAppearance() {
  const queryClient = useQueryClient();
  const query = useQuery({ queryKey: ["ownerTheme"], queryFn: ownerApi.getTheme });
  const [primary, setPrimary] = useState("");
  const [accent, setAccent] = useState("");
  const theme = query.data;
  const presets = theme?.presets ?? [];

  const apply = (preset_key, p, a) =>
    ownerApi.setTheme(preset_key, p, a).then(() => {
      queryClient.invalidateQueries({ queryKey: ["ownerTheme"] });
      queryClient.invalidateQueries({ queryKey: ["theme"] });
      toast.success("Theme updated — refresh to see it everywhere");
    }).catch((e) => toast.error(e.message));

  if (query.isPending) return <Spinner />;

  return (
    <div className="max-w-xl space-y-5">
      <div>
        <h3 className="mb-3 font-display text-sm font-bold">Brand presets</h3>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {presets.map((p) => (
            <button key={p.key} onClick={() => apply(p.key, p.primary, p.accent)} className={cn("rounded-xl border p-3 text-left", theme?.preset_key === p.key ? "border-primary" : "border-border")}>
              <div className="flex gap-1.5"><span className="h-6 w-6 rounded-full" style={{ background: p.primary }} /><span className="h-6 w-6 rounded-full" style={{ background: p.accent }} /></div>
              <p className="mt-2 text-xs font-semibold">{p.label}</p>
            </button>
          ))}
        </div>
      </div>
      <div>
        <h3 className="mb-3 font-display text-sm font-bold">Custom colors</h3>
        <div className="flex items-end gap-3">
          <label className="text-sm">Primary<input type="color" defaultValue={theme?.primary} onChange={(e) => setPrimary(e.target.value)} className="mt-1 block h-10 w-16 rounded border border-border" /></label>
          <label className="text-sm">Accent<input type="color" defaultValue={theme?.accent} onChange={(e) => setAccent(e.target.value)} className="mt-1 block h-10 w-16 rounded border border-border" /></label>
          <button onClick={() => apply("custom", primary || theme?.primary, accent || theme?.accent)} className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground">Apply</button>
        </div>
      </div>
      <button onClick={() => ownerApi.resetTheme().then(() => { queryClient.invalidateQueries({ queryKey: ["ownerTheme"] }); queryClient.invalidateQueries({ queryKey: ["theme"] }); toast.success("Reset to default"); })} className="text-sm font-semibold text-muted-foreground">Reset to default</button>
    </div>
  );
}
